import React from 'react'
import ModifySearch from './ModifySearch'
import PackageResult from './PackageResult'
import { ModifySearchProvider } from './hooks/useModifySearch'

const StaticPackage = () => {

    return (
        <ModifySearchProvider>
            <ModifySearch />
            <PackageResult />
        </ModifySearchProvider>
    )
}

export default StaticPackage